import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    textTransform: 'uppercase',
    fontWeight: 600,
  },
  pending: {
    color: theme.palette.companySupplier.progressStatus.pending.color,
    backgroundColor:
      theme.palette.companySupplier.progressStatus.pending.backgroundColor,
  },
  inProgress: {
    color: theme.palette.companySupplier.progressStatus.inProgress.color,
    backgroundColor:
      theme.palette.companySupplier.progressStatus.inProgress.backgroundColor,
  },
  completed: {
    color: theme.palette.companySupplier.progressStatus.completed.color,
    backgroundColor:
      theme.palette.companySupplier.progressStatus.completed.backgroundColor,
  },
  overdue: {
    color: theme.palette.companySupplier.progressStatus.overdue.color,
    backgroundColor:
      theme.palette.companySupplier.progressStatus.overdue.backgroundColor,
  },
  inactive: {
    color: theme.palette.companySupplier.status.inactive.color,
    backgroundColor:
      theme.palette.companySupplier.status.inactive.backgroundColor,
  },
}))

export default styles
